export default __webpack_public_path__ + "static/media/ktp700f.1d7f5e61.png";